import type { ApiClient } from '@prismo-io/schemas';
import { z } from 'zod';

const IdentifiedSkill = z.object({
  code: z.string(),
  value: z.number(),
});

export type IdentifiedSkillT = z.infer<typeof IdentifiedSkill>;

export const IdentifiedSkills = z.array(IdentifiedSkill);

export type IdentifiedSkillsT = z.infer<typeof IdentifiedSkills>;

const Appetence = z.object({
  code: z.string(),
  name: z.string(),
});

export type AppetenceT = z.infer<typeof Appetence>;

export const Appetences = z.array(Appetence);

export type AppetencesT = z.infer<typeof Appetences>;

export const fetchAppetences = async (
  client: ApiClient,
  userId: string
): Promise<AppetencesT> => {
  const { data: riasec } = await client
    .from('quark_riasec')
    .select('id, metadata->identified_skills')
    .eq('user_id', userId)
    .maybeSingle()
    .throwOnError();

  if (riasec && riasec.identified_skills) {
    const skills = IdentifiedSkills.parse(riasec.identified_skills).filter(
      (s) => s.value === 1
    );

    if (skills.length > 0) {
      const { data } = await client
        .from('ref_macro_skills')
        .select('code, name')
        .in(
          'code',
          skills.map((s) => s.code)
        );
      return Appetences.parse(data);
    }
    return [];
  }

  return [];
};
